var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-social-icon",attrs:{"href":_vm.url,"target":"_blank","title":_vm.title}},[_c('Icon',{attrs:{"icon":_vm.icon,"size":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }